module.exports = __webpack_public_path__ + "img/27.64cbbeac.png";